import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

export const LoyaltyContext = React.createContext();

export const LoyaltyProvider = ({ children }) => {
    const [loyalty, setLoyalty] = useState(
        window.drupalSettings && window.drupalSettings.loyalty,
    );

    return (
        <LoyaltyContext.Provider
            value={{
                name: loyalty && loyalty.name ? loyalty.name : '',
                image: loyalty && loyalty.image ? loyalty.image : '',
                setLoyalty,
            }}
        >
            {children}
        </LoyaltyContext.Provider>
    );
};

LoyaltyProvider.propTypes = {
    children: PropTypes.object.isRequired,
};

export const useLoyalty = () => useContext(LoyaltyContext);
